// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.choose-role-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #f4f4f4;
  padding: 20px;
}

.choose-role-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  padding: 40px;
  max-width: 600px;
  width: 100%;
  text-align: center;
}

.choose-role-card.error {
  background: #fee;
  border: 2px solid #f56565;
}

.choose-role-card h2 {
  color: #2d3748;
  margin-bottom: 15px;
  font-size: 2em;
  font-weight: 600;
}

.instruction {
  color: #718096;
  margin-bottom: 30px;
  line-height: 1.6;
  font-size: 1.05em;
}

.role-buttons {
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
  flex-wrap: wrap;
}

.role-button {
  flex: 1 1;
  min-width: 20rem;
  padding: 25px 20px;
  border: 2px solid transparent;
  border-radius: 12px;
  background: #f7fafc;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  text-align: center;
  align-self: center !important;
}

.role-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.role-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.admin-button {
  border-color: #44ACC9;
  background-color: white ;
}

.admin-button:hover:not(:disabled) {
  border-color: #44ACC9;
  background: linear-gradient(135deg, #44ACC9 0%, #44ACC9 100%);
}

.szakfelelos-button {
  border-color: #44ACC9;
  background-color: white ;
}

.szakfelelos-button:hover:not(:disabled) {
  border-color: #44ACC9;
  background: linear-gradient(135deg, #44ACC9 0%, #44ACC9 100%);
}

.role-icon {
  font-size: 2.5em;
  margin-bottom: 5px;
}

.role-content h3 {
  margin: 0 0 8px 0;
  color: #2d3748;
  font-size: 1.3em;
  font-weight: 600;
}

.role-content p {
  margin: 0;
  color: #4a5568;
  font-size: 0.95em;
  line-height: 1.4;
}

.error-message {
  background: #fed7d7;
  border: 1px solid #f56565;
  color: #c53030;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: 500;
}

.loading-message {
  background: #e6fffa;
  border: 1px solid #38b2ac;
  color: #234e52;
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.loading-message::before {
  content: "⏳";
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.cancel-section {
  border-top: 1px solid #e2e8f0;
  padding-top: 20px;
}

.cancel-button {
  background: transparent;
  border: 1px solid #cbd5e0;
  color: #4a5568;
  padding: 12px 24px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.95em;
  transition: all 0.2s ease;
}

.cancel-button:hover:not(:disabled) {
  background: #f7fafc;
  border-color: #a0aec0;
}

.cancel-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Mobile responsive */
@media (max-width: 768px) {
  .choose-role-container {
    padding: 10px;
  }
  
  .choose-role-card {
    padding: 30px 20px;
  }
  
  .role-buttons {
    flex-direction: column;
  }
  
  .role-button {
    min-width: auto;
  }
  
  .choose-role-card h2 {
    font-size: 1.6em;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ChooseRole.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".choose-role-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  background-color: #f4f4f4;\n  padding: 20px;\n}\n\n.choose-role-card {\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);\n  padding: 40px;\n  max-width: 600px;\n  width: 100%;\n  text-align: center;\n}\n\n.choose-role-card.error {\n  background: #fee;\n  border: 2px solid #f56565;\n}\n\n.choose-role-card h2 {\n  color: #2d3748;\n  margin-bottom: 15px;\n  font-size: 2em;\n  font-weight: 600;\n}\n\n.instruction {\n  color: #718096;\n  margin-bottom: 30px;\n  line-height: 1.6;\n  font-size: 1.05em;\n}\n\n.role-buttons {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 30px;\n  flex-wrap: wrap;\n}\n\n.role-button {\n  flex: 1;\n  min-width: 20rem;\n  padding: 25px 20px;\n  border: 2px solid transparent;\n  border-radius: 12px;\n  background: #f7fafc;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n  text-align: center;\n  align-self: center !important;\n}\n\n.role-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n.role-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.admin-button {\n  border-color: #44ACC9;\n  background-color: white ;\n}\n\n.admin-button:hover:not(:disabled) {\n  border-color: #44ACC9;\n  background: linear-gradient(135deg, #44ACC9 0%, #44ACC9 100%);\n}\n\n.szakfelelos-button {\n  border-color: #44ACC9;\n  background-color: white ;\n}\n\n.szakfelelos-button:hover:not(:disabled) {\n  border-color: #44ACC9;\n  background: linear-gradient(135deg, #44ACC9 0%, #44ACC9 100%);\n}\n\n.role-icon {\n  font-size: 2.5em;\n  margin-bottom: 5px;\n}\n\n.role-content h3 {\n  margin: 0 0 8px 0;\n  color: #2d3748;\n  font-size: 1.3em;\n  font-weight: 600;\n}\n\n.role-content p {\n  margin: 0;\n  color: #4a5568;\n  font-size: 0.95em;\n  line-height: 1.4;\n}\n\n.error-message {\n  background: #fed7d7;\n  border: 1px solid #f56565;\n  color: #c53030;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-weight: 500;\n}\n\n.loading-message {\n  background: #e6fffa;\n  border: 1px solid #38b2ac;\n  color: #234e52;\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n\n.loading-message::before {\n  content: \"⏳\";\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.cancel-section {\n  border-top: 1px solid #e2e8f0;\n  padding-top: 20px;\n}\n\n.cancel-button {\n  background: transparent;\n  border: 1px solid #cbd5e0;\n  color: #4a5568;\n  padding: 12px 24px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.95em;\n  transition: all 0.2s ease;\n}\n\n.cancel-button:hover:not(:disabled) {\n  background: #f7fafc;\n  border-color: #a0aec0;\n}\n\n.cancel-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Mobile responsive */\n@media (max-width: 768px) {\n  .choose-role-container {\n    padding: 10px;\n  }\n  \n  .choose-role-card {\n    padding: 30px 20px;\n  }\n  \n  .role-buttons {\n    flex-direction: column;\n  }\n  \n  .role-button {\n    min-width: auto;\n  }\n  \n  .choose-role-card h2 {\n    font-size: 1.6em;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
